export default "__VITE_ASSET__D7E4azl$__"